module.exports = __webpack_public_path__ + "img/leaf-branch.4f6037fe.svg";